import React from 'react';
import './Footer.css';

const navLinks = [
  { label: 'Menu', href: '#menu' },
  { label: 'Our Story', href: '#about' },
  { label: 'Reviews', href: '#testimonials' },
  { label: 'Contact', href: '#contact' },
];

export default function Footer() {
  const handleClick = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer-top-rule" />

      <div className="section-inner">
        <div className="footer-grid">
          {/* Brand */}
          <div className="footer-brand">
            <span className="footer-logo">AURUM</span>
            <span className="footer-logo-star">✦</span>
            <p className="footer-tagline">
              Where every plate is a portrait.<br />
              14 Rue de la Paix, Paris.
            </p>
          </div>

          {/* Navigation */}
          <div className="footer-col">
            <span className="footer-col-title">Navigate</span>
            <ul className="footer-links">
              {navLinks.map((l) => (
                <li key={l.label}>
                  <a href={l.href} onClick={(e) => handleClick(e, l.href)}>{l.label}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Hours */}
          <div className="footer-col">
            <span className="footer-col-title">Hours</span>
            <ul className="footer-hours">
              <li><span>Tue – Fri</span><span>6:30 PM – 11:30 PM</span></li>
              <li><span>Saturday</span><span>6:00 PM – Midnight</span></li>
              <li><span>Sunday</span><span>12:00 PM – 4:00 PM</span></li>
              <li><span>Monday</span><span>Closed</span></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-col">
            <span className="footer-col-title">Contact</span>
            <ul className="footer-links">
              <li><a href="tel:+33142860000">+33 1 42 86 00 00</a></li>
              <li><a href="mailto:hello@aurum-paris.com">hello@aurum-paris.com</a></li>
              <li><a href="#!">Instagram</a></li>
              <li><a href="#!">Facebook</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="footer-bottom">
          <span className="footer-copy">© {new Date().getFullYear()} Aurum. All rights reserved.</span>
          <div className="footer-awards">
            <span className="award-badge">✦ 2 Michelin Stars</span>
            <span className="award-badge">✦ World's 50 Best — #12</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
